module.exports = __webpack_public_path__ + "static/media/KFOlCnqEu92Fr1MmEU9fChc4AMP6lbBP.8c6805b0.woff2";